import { render, staticRenderFns } from "./GuiaRemision.vue?vue&type=template&id=53218ff6&"
import script from "./GuiaRemision.vue?vue&type=script&lang=js&"
export * from "./GuiaRemision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports